import { FormikHelpers } from "formik";
import { useCreateNode } from "./api/createNode";
import NodeForm from "./NodeForm";


const CreateNode = ({handleCloseModal}: CreateNodeProps)  => {
  const createNodeMutation = useCreateNode({data: {}});

  const initialValues: ICreateNodeForm = {
    description: "",
    modelID: "",
    unitID: "",
    hostName: "",
    x25NodeAddress: "",
    filepath: "",
    x25NodeNumber: "",
  };

  const handleSubmit = async (values: ICreateNodeForm, { setSubmitting }: FormikHelpers<ICreateNodeForm>): Promise<void> => {
    createNodeMutation.mutateAsync({
      data: values
    }).then(() => {
      handleCloseModal();
    }).catch((error) =>{
      console.log(error)
    })
    
    setSubmitting(false);
  }

  return (
    <></>
    //<NodeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateNodeProps {
  handleCloseModal: () => void;
}

export default CreateNode;